module.exports = __webpack_public_path__ + "img/distance.e6de1626.svg";